// @flow

// Constants
import {
  OPERATIONS_TREE,
  OPERATIONS_BRANCH,
} from 'hfty-model-orders'

import traverse from 'fc-utils/traverse'

export default (traverse([OPERATIONS_TREE, OPERATIONS_BRANCH]))
